export default __webpack_public_path__ + "static/media/ic_messages_120_gradient.0491a46b.svg";